import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    retrieve(parameters) {
        return requester.post(
            `${BACKEND_API_V1_URL}/enrollmentsstatus`,
            parameters
        )
    },
    update(parameters) {
        return requester.put(
            `${BACKEND_API_V1_URL}/enrollmentsstatus`,
            parameters
        )
    },

    create(parameters) {
        return requester.post(
            `${BACKEND_API_V1_URL}/enrollmentsstatus/create`,
            parameters
        )
    },

    delete(parameters) {
        return requester.put(
            `${BACKEND_API_V1_URL}/enrollmentsstatus/delete`,
            parameters
        )
    },

    restore(parameters) {
        return requester.put(
            `${BACKEND_API_V1_URL}/enrollmentsstatus/restore`,
            parameters
        )
    },

    flow: {
        retrieve(parameters) {
            return requester.get(
                `${BACKEND_API_V1_URL}/enrollmentsstatus/flow`,
                parameters
            )
        },
    },
}
